import { useToast } from "../context/ToastContext";
import "./ToastContainer.css";

const ToastContainer = () => {
  const { toasts, removeToast } = useToast();

  return (
    <div className="toast-container">
      {toasts.map((toast) => (
        <div key={toast.id} className={`toast toast-${toast.type}`}>
          <div className="toast-content">
            {(toast.type === "warning" || toast.type === "info") && (
              <span className="toast-icon">
                {toast.type === "warning" && "⚠"}
                {toast.type === "info" && "ℹ"}
              </span>
            )}
            <span className="toast-message">{toast.message}</span>
          </div>
          <button
            className="toast-close"
            onClick={() => removeToast(toast.id)}
            aria-label="Close notification"
          >
            ×
          </button>
        </div>
      ))}
    </div>
  );
};

export default ToastContainer;
